import { documentationActions } from '../../actions/constant';

const {
    CHECK_DISCHARGE_ALLOWS_REQUEST,
    CHECK_DISCHARGE_ALLOWS_SUCCESS,
    CHECK_DISCHARGE_ALLOWS_FAILURE,
    CHECK_DISCHARGE_ALLOWS_LOADING,
    CHECK_DISCHARGE_ALLOWS_RESET,
} = documentationActions;

const intitialstate: object = {
  response: null,
  isDischargeAllow: false,
  loading: false,
};

export const checkAllowDischargeReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case CHECK_DISCHARGE_ALLOWS_SUCCESS: {
      return {
        ...state,
        isDischargeAllow: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case CHECK_DISCHARGE_ALLOWS_FAILURE:
      return {
        ...state,
        isDischargeAllow: false,
        response: action.payload,
        loading: false,
      };

    case CHECK_DISCHARGE_ALLOWS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CHECK_DISCHARGE_ALLOWS_RESET:
      return intitialstate;

    default:
      return state;
  }
};
